import { DAY_OF_WEEK_ROUTER } from "callable-data-objects";
import { get as getWidget } from "Components/Device/Flow/constants";
import DeleteForm from "Components/Shared/DeleteForm";
import React, { useState } from "react";
import { Grid, Icon, Menu } from "semantic-ui-react";
import ConnectTo from "../Forms/ConnectTo";
import General from "../Forms/General";
import DayOfWeekRouterEdit from "./DayOfWeekRouterEdit";

const DayOfWeekRouterView = () => {
  const [activeMenu, setActiveMenu] = useState<string>("general");
  const widget = getWidget(DAY_OF_WEEK_ROUTER);
  return (
    <Grid stackable columns={2}>
      <Grid.Column width={3}>
        <Menu size='small' vertical fluid pointing>
          <Menu.Item header>
            <Icon name={widget.icon} color={widget.color} />
            {widget.name}
          </Menu.Item>
          <Menu.Item
            name='general'
            active={activeMenu === "general"}
            onClick={() => setActiveMenu("general")}
          >
            General Configuration
          </Menu.Item>
          <Menu.Item
            name='options'
            active={activeMenu === "options"}
            onClick={() => setActiveMenu("options")}
          >
            Options
          </Menu.Item>
          <Menu.Item
            name='onMatch'
            active={activeMenu === "onMatch"}
            onClick={() => setActiveMenu("onMatch")}
          >
            On Match
          </Menu.Item>
          <Menu.Item
            name='connectTo'
            active={activeMenu === "connectTo"}
            onClick={() => setActiveMenu("connectTo")}
          >
            No Match
          </Menu.Item>
          <Menu.Item
            name='delete'
            active={activeMenu === "delete"}
            onClick={() => setActiveMenu("delete")}
          >
            Delete
          </Menu.Item>
        </Menu>
      </Grid.Column>
      <Grid.Column width={13}>
        {activeMenu === "options" && <DayOfWeekRouterEdit />}
        {activeMenu === "general" && <General />}
        {activeMenu === "connectTo" && (
          <ConnectTo type='dayOfWeekRoute' field='connectTo' />
        )}
        {activeMenu === "onMatch" && (
          <ConnectTo type='dayOfWeekRoute' field='onMatch' />
        )}
        {activeMenu === "delete" && <DeleteForm />}
      </Grid.Column>
    </Grid>
  );
};

export default DayOfWeekRouterView;
